import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

const Modal = ({
	               isShowing,
	               hide,
	               title,
	               closeButton = true,
	               footer = false,
	               className = '',
	               ...props
               }) =>
	isShowing
		? ReactDOM.createPortal(
			<>
				<div
					className={'modal fade show ' + className}
					tabIndex="-1"
					role="dialog"
					aria-labelledby="{title}"
					aria-modal="true"
				>
					<div className="modal-background"></div>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabelDefault">{title}</h5>
								{closeButton && (
									<button onClick={hide}
									        type="button"
									        className="btn-close"
									        data-bs-dismiss="modal"
									        aria-label="Close"
									/>
								)}
							</div>
							<div className="modal-body">
								{props.children}
							</div>
							{footer && (
								<div className="modal-footer">
									{footer}
								</div>
							)}
						</div>
					</div>
				</div>
			</>,
			document.body
		)
		: null;

Modal.propTypes = {
	isShowing: PropTypes.bool.isRequired,
	hide: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired
};

export default Modal;
